export default __webpack_public_path__ + "static/spitz-screens-eaea43bddfedb523ac33956a9d5080ea.jpg";